import {Workload} from '../../../../component/workload/workload';
import {PageCard} from '../../../../layout/page-card/page-card';
import {Locale} from '../../../../provider/locale/locale';
import {useWorkload} from '../../../../service/analytics-workload/analytics-workload-hook';
import {ProvidersIdsEnum} from '../../../../util/type';
import {DashboardWidgetEnum} from '../dashboard-type';
import {DashboardWidgetHeader} from '../dashboard-widget-header/dashboard-widget-header';

type PropsType = {
    companyId: number;
    isDashboardWidget?: boolean;
};

export function AnalyticsWorkLoadPageCard(props: PropsType): JSX.Element {
    const {companyId, isDashboardWidget} = props;

    const {result: data, processError, isInProgress, isDataEmpty} = useWorkload(companyId, ProvidersIdsEnum.google);

    return (
        <PageCard
            title={
                <DashboardWidgetHeader
                    title={<Locale stringKey="DASHBOARD_PAGE__WORKLOAD__TITLE" />}
                    widget={isDashboardWidget ? DashboardWidgetEnum.Workload : null}
                />
            }
        >
            <Workload
                emptyLangKey="DASHBOARD_PAGE__WORKLOAD__EMPTY"
                footerLangKey="DASHBOARD_PAGE__WORKLOAD__FOOTER"
                hasProcessError={Boolean(processError)}
                isEmpty={isDataEmpty}
                isInProgress={isInProgress}
                workloadData={data}
            />
        </PageCard>
    );
}
